import React from "react";
import Sidebar from "./Sidebar";
import Header from "../layout/Header";
import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../Config/Config.js";

const ManagementRVS = () => {
  const [presidents, setPresidents] = useState([]);
  const [mainMembers, setMainMembers] = useState([]);

  /* ================= PRESIDENT ================= */
  const fetchPresident = async () => {
    try {
      const docRef = doc(db, "Others", "RVSPresident");
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const dataArray = Object.values(docSnap.data());
        setPresidents(dataArray);
      }
    } catch (error) {
      console.error("Error fetching president:", error);
    }
  };

  /* ================= MAIN MEMBERS ================= */
  const fetchMainMembers = async () => {
    try {
      const docRef = doc(db, "Others", "MainMembers");
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const dataArray = Object.values(docSnap.data());
        setMainMembers(dataArray);
      }
    } catch (error) {
      console.error("Error fetching main members:", error);
    }
  };

  useEffect(() => {
    fetchPresident();
    fetchMainMembers();
  }, []);

  return (
    <div className="site-main">
      <Header />

      <div className="ttm-page-title-row explorebanner">
        <div className="container-xl">
          <div className="row">
            <div className="col-md-12">
              <div className="title-box text-center">
                <div className="page-title-heading card_box">
                  <h4 className="title" style={{ color: "white" }}>
                    Management RVS
                  </h4>
                  <div className="ttm-color-home">
                    <span className="ttm-color-home">
                      <a
                        className="ttm-color-home"
                        title="Homepage"
                        href={process.env.PUBLIC_URL + "/"}
                      >
                        <i className="ti ti-home" />
                        &nbsp;&nbsp;Home
                      </a>
                    </span>
                    <span className="ttm-bread-sep">&nbsp; : : &nbsp;</span>
                    <span className="ttm-color-home">RVS</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="grid-section clearfix">
        <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
          <div className="container-xl">
            <div className="row">
              <div className="col-lg-9 content-area order-lg-2">
                <div className="ttm-service-single-content-area">
                  <div className="section-title with-desc text-left clearfix">
                    <div className="title-header">
                      <h2 className="title">
                        Rajya Vokkaliga Sangha <span>(RVS)</span>
                      </h2>
                    </div>
                  </div>

                  <div className="ttm-service-description text-justify">
                    Our management, Rajya Vokkaligara Sangha (RVS) was founded
                    in the year 1906 to promote social, cultural and educational
                    aspirations of the agricultural community. Rajya Vokkaligara
                    Sangha with a commanding presence in Bangalore, Ramanagara,
                    Mandya, Mysore, Chikkamagalur, Hassan, Tumkur,
                    Chikkaballapura, Kolar and Chitradurga districts and with a
                    fairly well spread presence in other regions of Karnataka
                    has been conducting number of regular activities for the
                    development and well being of the community in particular
                    and to all sections of the society in general. The sangha
                    has also provided hostel facilities for poor background
                    student and students are making use of this hostel
                    facilities during their education carreer. The Rajya
                    Vokkaligara Sangha comprise of 35 directors
                  </div>

                  <div className="separator">
                    <div className="sep-line mt-35 mb-35 res-991-mtb-20" />
                  </div>

                  <div className="section-title with-desc text-left clearfix">
                    <div className="title-header">
                      <h2 className="title">
                        Organizational <span>Structure</span>
                      </h2>
                    </div>
                  </div>

                  <div className="row ttm-service-description text-center">
                    {presidents
                      .filter((p) => p.Designation === "President")
                      .map((p, index) => (
                        <div
                          key={index}
                          className="col-md-6 offset-md-3 paddingtop-1"
                        >
                          <img
                            className="img-fluid"
                            src={p.Image}
                            alt={p.Name}
                          />
                          <h5 className="paddingtop-1">{p.Name}</h5>
                          <h6>{p.Designation}</h6>
                        </div>
                      ))}

                    {mainMembers.map((member, index) => (
                      <div className="col-md-4 paddingtop-2" key={index}>
                        <img
                          className="img-fluid"
                          src={member.Image}
                          alt={member.Name}
                        />
                        <h6 className="paddingtop-1">{member.Name}</h6>
                        <small>{member.Designation}</small>
                      </div>
                    ))}
                  </div>

                  <div className="ttm-service-single-content-area">
                    <div className="section-title with-desc text-left clearfix paddingtop-2">
                      <div className="title-header">
                        <h4 className="title">Executive Council Members</h4>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-6">
                        <ul className="ttm-list ttm-list-textsize-medium ttm-list-style-icon pt-15">
                          <li>Sri.M.Puttaswamy</li>
                          <li>Dr.T.H.Anjanappa</li>
                          <li>Sri.H.N.Ashoka</li>
                          <li>Sri.B.Kenchappa Gowda</li>
                          <li>Sri.C.Devaraju</li>
                          <li>Sri.H.C.Jayamuthu</li>
                          <li>Sri.C.M.Maregowda</li>
                          <li>Sri.L.Srinivas</li>
                        </ul>
                      </div>

                      <div className="col-lg-6">
                        <ul className="ttm-list ttm-list-textsize-medium ttm-list-style-icon pt-15">
                          <li>Sri.S.J.Ashok Jayaram</li>
                          <li>Dr.M.B.Manjegowda</li>
                          <li>Sri.Chandrashekar</li>
                          <li>Sri.N.Balakrishna</li>
                          <li>Sri.B.P.Manjegowda</li>
                          <li>Sri.S.S.Raghugowda</li>
                          <li>Sri.Hanumatharayappa R</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 widget-area">
                <Sidebar />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ManagementRVS;
